// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FEjeyyLVzuW_EMqzG9j9{width:100%}", "",{"version":3,"sources":["webpack://./../next-react/src/components/modals/ExternalBookingsModal/styles.scss"],"names":[],"mappings":"AAEE,sBACE,UAAA","sourcesContent":["$theme: next;\n.ExternalBookingsModal {\n  &_button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ExternalBookingsModal_button": "FEjeyyLVzuW_EMqzG9j9"
};
export default ___CSS_LOADER_EXPORT___;
